import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-status-document',
  templateUrl: './status-document.component.html',
  styleUrls: ['./status-document.component.scss']
})
export class StatusDocumentComponent implements OnInit {

  contactId = ""
  ticketId = ""
  statusDate = ""
  statusText = ""
  status = 0

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.contactId = this.activatedRoute.snapshot.paramMap.get('id');
    this.bindData()

  }

  async bindData(){
    try{
      let ticket: any = await this.apiService.get("crmservice", "searchApprovalTicket", "contactid=" + this.contactId)
      if(ticket != null && ticket.length > 0){
        this.util.ShowWaiting(false)
        this.status = parseInt(ticket[0].dpa_approvalstatuscode)
        if(this.status == 1){
          this.statusText = "กำลังตรวจสอบเอกสาร"
        }
        else if(this.status == 2){
          this.statusText = "กำลังทำการอนุมัติเอกสาร"
        }
        else if(this.status == 6){
          this.statusText = ticket[0].dpa_remark == null ? '' : ticket[0].dpa_remark
        }
        else{
          this.router.navigate(["mainmenu/index"])
        }
        this.statusDate = ticket[0].dpa_submitdate
      }
      else{
        this.util.ShowWaiting(false)
        this.util.ErrorDialog("ไม่พบข้อมูลกรุณาติดต่อเจ้าหน้าที่")
      }
    }
    catch(e){
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่")
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/status-document/status-document.component.ts